import Markdown from "react-markdown";
import type { Scene as SceneType } from "../types";
import { ArrowRight } from "./icons";

interface Props {
  scene: SceneType;
  step: number;
  onChoose: (target: string) => void;
}

export function Scene({ scene, step, onChoose }: Props) {
  const isEnding = scene.tags?.includes("Ending");

  return (
    <section className="scene-grid">
      <div className="scene-left">
        <div className="scene-eyebrow">
          {isEnding ? (
            <>
              <span className="ending-pill">
                <span className="dot" />
                Leg complete
              </span>
              <span className="num">{scene.id}</span>
            </>
          ) : (
            <>
              <span>Scene</span>
              <span className="num">{scene.id}</span>
            </>
          )}
        </div>

        <h2 className="scene-title">{scene.title}</h2>

        {scene.tags && scene.tags.length > 0 && (
          <ul className="scene-tags">
            {scene.tags.map((t) => (
              <li key={t} className="scene-tag">{t}</li>
            ))}
          </ul>
        )}

        <div className="scene-story">
          <Markdown>{scene.storyText}</Markdown>
        </div>

        {scene.techPanel && (
          <details className="scene-tech">
            <summary>
              <span>Tech panel</span>
              <span className="hint">SE enablement</span>
            </summary>
            <div className="scene-tech-body">
              <Markdown>{scene.techPanel}</Markdown>
            </div>
          </details>
        )}
      </div>

      <aside className="scene-right">
        <div className="choices-pane">
          <div className="choices-label">
            <span>Choose your line</span>
            <span className="count">
              {scene.choices.length} {scene.choices.length === 1 ? "OPEN" : "OPEN"}
            </span>
          </div>
          {scene.choices.length > 0 ? (
            <ul className="choices">
              {scene.choices.map((c, i) => (
                <li key={c.id}>
                  <button className="choice" onClick={() => onChoose(c.target)}>
                    <span className="choice-key">{String(i + 1)}</span>
                    <span className="choice-text">{c.label}</span>
                    <span className="choice-arrow"><ArrowRight /></span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="no-choices">○ End of branch — terminal node.</p>
          )}

          <div className="step-meta">
            <span className="k">Step</span>
            <span className="v">{String(step).padStart(2, "0")}</span>
          </div>
        </div>
      </aside>
    </section>
  );
}
